import {
    URLAPI,
    NOTE_PATH,
    NOTE_ITEM_PATH,
    NOTE_CREATE_PATH,
    NOTE_REPORT_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_note: {
        data: [],

        status: 0,
        message: {},
    },
    _create_note: {
        data: {},
        status: 0,
        message: {},
    },
    _get_report: {
        data: {},
        status: 0,
        message: "",
    },
};

const GET_ALL_NOTE = "GET_ALL_NOTE";
export const CREATE_NOTE = "CREATE_NOTE";
export const GET_REPORT = "GET_REPORT";

export const note_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_NOTE:
            return {
                ...state,
                _get_all_note: action.payload,
            };
        case CREATE_NOTE:
            return {
                ...state,
                _create_note: action.payload,
            };
        case GET_REPORT:
            return {
                ...state,
                _get_report: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllNote = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${NOTE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_NOTE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_NOTE,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_NOTE,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const getItemNote = async (token, id) => {
    return await axios.get(`${URLAPI}${NOTE_ITEM_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
};

//create note
export const createNote = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${NOTE_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_NOTE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_NOTE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_NOTE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const get_report = (data, token) => async (dispatch) => {
    try {
        const res = await axios.post(URLAPI + NOTE_REPORT_PATH, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });

        dispatch({
            type: GET_REPORT,
            payload: {
                data: res.data,
                status: res.status,
                message: "",
            },
        });
    } catch (e) {
        dispatch({
            type: GET_REPORT,
            payload: {
                data: {},
                status: 500,
                message: "Ocurrio un error al generar el reporte",
            },
        });
    }
};

export const clear_note = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
